/**
 * Repasse do e-mail digitado na descoberta de tenant (Home Realm Discovery)
 * para a tela de senha do Keycloak, via `login_hint` — evita o usuario ter
 * que digitar o e-mail de novo lá. Sobrevive a um reload (necessario porque
 * o bootstrap do Keycloak so roda depois de descobrir o tenant), mas nao a
 * uma nova aba/sessao: sessionStorage, nao localStorage.
 */

const STORAGE_KEY = "inbim.login-hint.v1";

/** Guarda o e-mail para uso pelo proximo login() apos o reload do bootstrap. */
export function storeLoginHint(email: string): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, email);
  } catch {
    // sessionStorage indisponivel — segue sem hint, usuario digita de novo no Keycloak.
  }
}

/** Le e limpa o hint guardado — uso unico, para nao vazar em logins subsequentes. */
export function consumeLoginHint(): string | undefined {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    if (value) window.sessionStorage.removeItem(STORAGE_KEY);
    return value ?? undefined;
  } catch {
    return undefined;
  }
}
